'use strict';exports.__esModule = true;var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _UploadAssetWidget = require('../UploadAssetWidget.scss');var styles = _interopRequireWildcard(_UploadAssetWidget);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var ImageControls = function ImageControls(properties) {var _cx;return (
    _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.controls, (_cx = {}, _cx[styles.mobileControls] = properties.isTabletDevice, _cx)) },
      !properties.isVideo && properties.mainImageTitle,
      _react2.default.createElement('span', {
        title: properties.deleteFileTitle,
        onClick: properties.deleteImage,
        className: styles.delete + ' icon icon-close' }),

      !properties.isVideo && !properties.isRaw &&
      _react2.default.createElement('span', {
        title: properties.rotateImageTitle,
        onClick: properties.rotateImage,
        className: styles.rotate + ' icon icon-rotate' })));};exports.default =





ImageControls;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UploadAssetWidget/HelpComponents/ImageControls.js
// module id = 2902
// module chunks = 0